module.exports = __webpack_public_path__ + "img/avatar-1.a3e7e857.png";